import React from "react";

import {
  Box,
  Heading,
  Link,
  Image,
  SimpleGrid,
  Stack,
  Text,
  Flex,
  Button,
} from "@chakra-ui/react";

const Project = () => {
  const ProjectData = [
    {
      title: "CSS Code Generator",
      link: "https://css-code-generator.vercel.app",
      url: "https://github.com/chhavi48/CSS_Code_Generator",
      description:
        "Create custom CSS box shadows with ease! This web-based tool allows you to customize box shadows for your web projects. Adjust parameters like color, blur radius, spread radius, shift, border radius, and apply transformations. One-click copy of CSS code snippets for easy integration.css open source project .",
      language:["React JS"," ","TypeScript"," "],
      image:
        "https://github.com/chhavi48/portfolio-new/assets/77965216/42e9f1a0-a73d-4f5c-a859-8a13de469aab",
    },
    {
      title: "PostMan_Clone",
      link: "https://post-man-clone-cs.netlify.app/",
      url: "https://github.com/chhavi48/PostMan_Clone",
      description:
        
        "PostMan Clone using the Reactjs. you can create the GET and POST request also i am working on this project and trying to add other requests.",
      language: ["Reactjs", " ", "MUI", " "],
      image:
        "https://user-images.githubusercontent.com/77965216/205920651-781f09e8-a0b9-4e7a-a59f-1d50f576f24c.png",
    },
    {
      title: "Resume Builder",
      link: "https://resume-builder-cssv.vercel.app/",
      url: "https://github.com/chhavi48/ResumeBuilder/tree/main",
      description:
        "This is a personal project based Professional Resume Builder, with downloading in PDF format feature. Made with the help of react redux.",
      language: ["React", " ", "Redux", " ", "React-print"],
      image:
        "https://user-images.githubusercontent.com/94439105/175854197-45c646f0-1a11-4039-b633-efbd452075ca.png",
    },
    {
      title: "Dino_Chrome_Game_Clone",
      link: "https://dino-chrome-game-clone.vercel.app/",
      url: "https://github.com/chhavi48/Dino_Chrome_Game_Clone",
      description:
        "Trying to clone the Dino game and working on some functionality as the game ",
      language: ['HTMl', " ", "Css"," ","js"],
      image:
        "https://user-images.githubusercontent.com/77965216/227753329-c1777669-3400-4432-a48f-d80a90382fa1.png",
    },
    {
      title: "Instagram-Clone",
      link: "https://instagramclonechhavi.vercel.app/",
      url: "https://github.com/chhavi48/Instagram_Clone",
      description:
        "Instagram clone for the learn about basic idea of backend and plugin",
      language: ["React", " ", "Nodejs", " ","ExpressJs"," ","ChakraUI"],
      image:
        "https://user-images.githubusercontent.com/77965216/204134691-226feb2e-4f6f-4058-a79c-2d6d172229ad.png",
    },
    {
      title: "Paint Application",
      link: "https://chhavi-paint-app.netlify.app/",
      url: "https://github.com/chhavi48/Paint-App",
      description:
        "Paint-App for laptop and desktop ,you can draw something and also able to fill Color, save your image's in JPG formet .",
      language: ["Html", " ", "Css", " ", "JavaScript"],
      image:
        "https://user-images.githubusercontent.com/77965216/189705574-9f046a28-a184-460f-8cd9-8a46dde45a9f.png",
    },
    {
      title: "Tracking Time - Clone",
      link: "https://trackingtimemasai.vercel.app/",
      url: "https://github.com/chhavi48/dainty-market-1579",
      description:
        "TrackingTime is an intuitive Time Tracking Software. Simplify Timesheets. Get accurate clients, project and employee reports. Give it a try!",
        language: ["Reactjs", " ", "NodeJs", " ", "ExpressJs" ," Mongodb"],
      image:
        "https://user-images.githubusercontent.com/70229744/187068343-07604dbc-b919-47d7-9b04-9d6042a44474.png",
    },
    {
      title: "Cric_Live",
      link: "https://github.com/S-hub1996/cric_live",
      url: "https://cric-live.vercel.app/",
      description:
        "Feathers of the website : can see the total matches(comes from the API ) ,See more details about the one card , Search the card (by Country Name ),Apply dark and light mode",
      language: ["Reactjs", " Chakra UI", ""],
      image:
        "https://user-images.githubusercontent.com/77965216/205295632-0df642d4-6990-43eb-a4be-45f8e2c33664.png",
    },
    {
      title: "Hand Gesture",
      link: "http://gesture-recognition-hazel.vercel.app/",
      url: "https://github.com/chhavi48/GestureRecognition",
      description:
        "A real time gesture recognition app using Tensorflow.JS, a pre-trained handpose model and the fingerpose library.",
        language: ["React"," ","Tensorflow"],
      image:
        "https://user-images.githubusercontent.com/77965216/188686110-a8151ea8-42f3-4d55-9ac1-0a5038dd5e58.png",
    },
  ];
  return (
    <Box mt={40} id="projects">
      <Heading color={"blue.500"}>Projects</Heading>
      <SimpleGrid columns={[1, 1, 2, 3]} spacing={4} mt={8}>
        {ProjectData.map((t) => {
          return (
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              border="1px solid"
              borderColor={"gray.300"}
              rounded={"xl"}
              mx={8}
              p={2}
            >
              <Image src={t.image} />
              <Text fontSize={"1.3rem"}>{t.title}</Text>
              <Text>{t.language}</Text>
              <Text>{t.description}</Text>

              <Flex justifyContent={"space-between"} gap={[4]}>
                <Button target="_blank" as="a" href={t.url} bg={"blue.300"}>
                  Github
                </Button>
                <Button as="a" href={t.link} target="_blank">
                  Go live
                </Button>
              </Flex>
            </Stack>
          );
        })}
      </SimpleGrid>
    </Box>
  );
};

export default Project;
